import { useDispatch } from 'react-redux';

/**
 * The store's `clientMiddleware` does not behave the way react-redux's default
 * `Dispatch` type describes it. For an action carrying a `promise` it awaits that
 * promise and returns the **result**, and for a thunk it returns
 * `action(dispatch, getState)` — in neither case the action object itself.
 *
 * So `await dispatch(fetchThing())` resolves to the API payload, while the
 * default typing reports the action creator's literal shape
 * (`{ promise, types, auth }`), which is why reading a field off the result is an
 * error at every call site.
 *
 * The payload type is genuinely unknown here: the actions are untyped JS and the
 * middleware forwards whatever the client returned. `any` states that, rather
 * than a shape that is wrong.
 */
type AppDispatch = (action: any) => any;

export const useAppDispatch = (): AppDispatch => useDispatch();
